import { HiddenSectionsProvider } from '@ltvco/refresh-lib/ctx';
import { Box, Text, styled } from '@ltvco/refresh-lib/theme';
import { LoadingDots } from '@ltvco/refresh-lib/v1';
import { useParams } from 'react-router-dom';

import { CourtCaseDisclaimer } from '../../shared';

import { ReportBreadcrumbs } from './ReportBreadcrumbs/ReportBreadcrumbs';
import { ReportSectionsView } from './ReportSectionsView';
import { useDocketDetailReport } from './useDocketDetailReport';

const PageWrap = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 800,
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  paddingBottom: theme.spacing(3),
}));

const isDigitsOnlyDocketParam = (id: string | undefined) => {
  const trimmed = id?.trim();
  return Boolean(trimmed && /^\d+$/.test(trimmed));
};

export function CourtCaseReport() {
  const { docketId } = useParams<{ docketId: string }>();
  const query = useDocketDetailReport(docketId);
  const hasValidDocketId = isDigitsOnlyDocketParam(docketId);

  return (
    <PageWrap>
      {!hasValidDocketId ? (
        <Text color="error">Invalid report link.</Text>
      ) : query.isLoading ? (
        <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
          <LoadingDots count={5} />
        </Box>
      ) : query.isError ? (
        <Text color="error">
          {query.error instanceof Error
            ? query.error.message
            : 'Unable to load this report.'}
        </Text>
      ) : query.data?.sections ? (
        <HiddenSectionsProvider reportType="class_action_lawsuit_report">
          <Box>
            <ReportBreadcrumbs header={query.data.sections.header} />
            <ReportSectionsView sections={query.data.sections} />
            <CourtCaseDisclaimer />
          </Box>
        </HiddenSectionsProvider>
      ) : (
        <Text color="text.secondary">No report data available.</Text>
      )}
    </PageWrap>
  );
}
